import { api } from "@/api";
import { ANALYTICS_EVENTS } from "@/data/polyFitData";

let lastSignature = "";
let lastFiredAt = 0;

export function trackAdvisorEvent(eventName, payload = {}) {
  if (!ANALYTICS_EVENTS.includes(eventName)) return;
  try { if (window.self !== window.top) return; } catch { return; }
  const signature = `${eventName}:${JSON.stringify(payload)}`;
  if (signature === lastSignature && Date.now() - lastFiredAt < 1500) return;
  lastSignature = signature;
  lastFiredAt = Date.now();
  const event = { event_name: eventName, payload, session_id: payload.sessionId || payload.session_id || null, created_at: new Date().toISOString() };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...payload });
  try {
    const events = JSON.parse(window.localStorage.getItem("polyFitAnalyticsEvents") || "[]");
    events.push(event);
    window.localStorage.setItem("polyFitAnalyticsEvents", JSON.stringify(events.slice(-80)));
  } catch {
    window.localStorage.setItem("polyFitAnalyticsEvents", JSON.stringify([event]));
  }
  api.captureAdvisorAnalytics(eventName, payload).catch(() => undefined);
}